import { forwardRef, type SelectHTMLAttributes } from 'react';

interface NativeSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  containerClassName?: string;
}

const NativeSelect = forwardRef<HTMLSelectElement, NativeSelectProps>(
  function NativeSelect(
    { children, className = '', containerClassName = '', ...props },
    ref
  ) {
    return (
      <span className={`relative block w-full ${containerClassName}`}>
        <select
          className={`${className} w-full cursor-pointer disabled:cursor-not-allowed`}
          ref={ref}
          {...props}
        >
          {children}
        </select>
      </span>
    );
  }
);

export default NativeSelect;
